export const INCREMENT_COUNTER = "INCREMENT_COUNTER";
export const DECREMENT_COUNTER = "DECREMENT_COUNTER";

export const TOGGLE_HEADER = "TOGGLE_HEADER";
export const TOGGLE_RIGHT_PANE = "TOGGLE_RIGHT_PANE";
export const TOGGLE_LEFT_NAV = "TOGGLE_LEFT_NAV";

export const CHANGE_ROUTE = "CHANGE_ROUTE";

export const UN_FOCUS = "UN_FOCUS";

export const CHART_SET_PERIOD = "CHART_SET_PERIOD";

export const CHART_PAGE_LAYOUT_CHANGE = "CHART_PAGE_LAYOUT_CHANGE";

export const CHART_PAGE_SET_DATA = "CHART_PAGE_SET_DATA";
export const CHART_SHOW_SETTINGS = "CHART_SHOW_SETTINGS";

export const CHART_SHOW_INDICATOR_SETTINGS = "CHART_SHOW_INDICATOR_SETTINGS";
export const CHART_HIDE_INDICATOR_SETTINGS = "CHART_HIDE_INDICATOR_SETTINGS";

export const CHART_PAGE_EXCHANGE_DROPDOWN_TOGGLE = "CHART_PAGE_EXCHANGE_DROPDOWN_TOGGLE";
export const CHART_PAGE_EXCHANGE_SELECT = "CHART_PAGE_EXCHANGE_SELECT";

export const CHART_PAGE_SECURITY_FOCUS = "CHART_PAGE_SECURITY_FOCUS";
export const CHART_PAGE_SECURITY_SEARCH = "CHART_PAGE_SECURITY_SEARCH";
export const CHART_PAGE_LOADING = "CHART_PAGE_LOADING";
export const CHART_PAGE_SECURITY_SELECT = "CHART_PAGE_SECURITY_SELECT";

export const CHART_PAGE_CHART_TYPE_DROPDOWN_TOGGLE = "CHART_PAGE_CHART_TYPE_DROPDOWN_TOGGLE";
export const CHART_PAGE_CHART_TYPE_SELECT = "CHART_PAGE_CHART_TYPE_SELECT";

export const CHART_PAGE_CHART_INDICATOR_DROPDOWN_TOGGLE = "CHART_PAGE_CHART_INDICATOR_DROPDOWN_TOGGLE";
export const CHART_PAGE_CHART_INDICATOR_ADD = "CHART_PAGE_CHART_INDICATOR_ADD";
export const CHART_PAGE_CHART_INDICATOR_REMOVE = "CHART_PAGE_CHART_INDICATOR_REMOVE";
export const CHART_PAGE_CHART_INDICATOR_UPDATE = "CHART_PAGE_CHART_INDICATOR_UPDATE";

export const CHART_PAGE_CHART_INTERACTIVE_INDICATOR_DROPDOWN_TOGGLE = "CHART_PAGE_CHART_INTERACTIVE_INDICATOR_DROPDOWN_TOGGLE";
export const CHART_PAGE_CHART_INTERACTIVE_INDICATOR_SET = "CHART_PAGE_CHART_INTERACTIVE_INDICATOR_SET";

export const CHART_PAGE_CHART_SETTINGS_DROPDOWN_TOGGLE = "CHART_PAGE_CHART_SETTINGS_DROPDOWN_TOGGLE";
export const CHART_PAGE_CHART_SETTINGS_CHANGE = "CHART_PAGE_CHART_SETTINGS_CHANGE";

export const DEMO_COMPLETE = "DEMO_COMPLETE";

export const WINDOW_RESIZE = "WINDOW_RESIZE";
export const CHART_PAGE_RESIZE_COMPLETE = "CHART_PAGE_RESIZE_COMPLETE";

export const ESCAPE = "ESCAPE";




/** WEBPACK FOOTER **
 ** ./src/scripts/constants/ActionTypes.js
 **/